import { captureException, captureMessage, init } from "@sentry/browser"
import { CaptureConsole } from "@sentry/integrations"
import gitProperties from "../../git.properties.json"
import { scrubBreadcrumb, scrubEvent } from "./sentry-scrub"

const dsnConfig = document.querySelector('meta[name~="machtfit-sentry-dsn"]')
const environmentConfig = document.querySelector('meta[name~="machtfit-sentry-environment"]')
const userIdConfig = document.querySelector('meta[name~="machtfit-sentry-user-id"]')
const dsn = dsnConfig?.getAttribute("content")
const environment = environmentConfig?.getAttribute("content")
const userId = userIdConfig?.getAttribute("content")

const IGNORED_THIRD_PARTY_CONSOLE_ERRORS = ["Failed to fetch feature flags from PostHog."]

function initSentry() {
  if (!dsn) {
    console.warn("No sentry DSN URL configured. Not initializing sentry.")
    return
  }

  if (window.location.protocol === "file:") {
    console.warn("Page opened from a local file. Not initializing sentry.")
    return
  }

  const release = gitProperties?.hash

  if (release) {
    // tests/e2e/auth.setup.ts reads this line to record the instance's revision.
    console.log(`Running release ${release}.`)
  } else {
    console.warn("No release information. Initializing Sentry without a release.")
  }

  init({
    dsn,
    release,
    integrations: [new CaptureConsole({ levels: ["error"] })],
    ignoreErrors: IGNORED_THIRD_PARTY_CONSOLE_ERRORS,
    beforeSend: scrubEvent,
    beforeBreadcrumb: scrubBreadcrumb,
    environment: environment,
    initialScope: {
      user: {
        id: userId,
      },
    },
  })

  window.mfSentry = { captureException, captureMessage }
}

initSentry()
